/* @flow */

import _ from 'lodash';

export const getIntelligenceBySlug = ({ intelligences }: Object, topic: string) => (_.find(intelligences, { slug: topic.toUpperCase() }) || {});
